// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore, collection, addDoc, serverTimestamp } from 'firebase/firestore';

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyBVmVYYsvHM_f-wqhoSLN3D5GsRVw0jY5c",
    authDomain: "quran-academy-a83f8.firebaseapp.com",
    projectId: "quran-academy-a83f8",
    storageBucket: "quran-academy-a83f8.appspot.com",
    messagingSenderId: "405230021355",
    appId: "1:405230021355:web:12e07d47e701b2174eecae",
    measurementId: "G-Z90ZS6SFQY"
  };
  
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db, collection, addDoc, serverTimestamp };
